'use strict';

var $ = require('jquery');
var MappedBookingDirective = function MappedBookingDirective($rootScope) {
  return {
    restrict: 'E',
    template: require('../templates/mapped-rules.html'),
    controller: 'MappedRulesController',
    scope: {
      entityData: '=',
      mode: '@',
      headerFormat: '@?'
    },
    link: function link(scope, element) {
      element.on('click', 'a.readOnlyRule', function (e) {
        e.preventDefault();
        $rootScope.$broadcast('read-only-rule:show', $(this).data('uid'));
        e.stopPropagation();
        return false;
      });
    }
  };
};
MappedBookingDirective.$inject = ['$rootScope'];
module.exports = MappedBookingDirective;